import { ActionField } from 'schemaBuilder/types';
import { test as validate, enforce } from 'vest';

export default (field: Partial<ActionField>, fieldPath: string) => {
  validate(`${fieldPath}.type`, `Please fill in all field types`, () => {
    enforce(field.type).isNotEmpty();
  });
};
